export enum PhoneNumberPortingStatus {
    New,
    Ordered,
    Accepted,
    CarrierAck,
    Confirmed,
    Cancel,
    Rejected,
    Executed,
    Cancelled
}